import { css } from "@emotion/react";
import React, { forwardRef } from "react";
import { Paper } from "../Paper";
import { useTheme } from "../theme";

export interface CardContentProps extends React.ComponentPropsWithoutRef<"div"> {
  children?: React.ReactNode;
}

export const CardContent = forwardRef<HTMLDivElement, CardContentProps>(
  ({ children, ...props }, ref) => {
    const { spacing } = useTheme();
    return (
      <div
        ref={ref}
        {...props}
        css={css`
          padding: ${spacing * 2}px;
        `}
      >
        {children}
      </div>
    );
  },
);
CardContent.displayName = "CardContent";

export interface CardProps extends React.ComponentPropsWithoutRef<"div"> {
  children?: React.ReactNode;
}

/**
 * だいたいPaperと同じ。
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, ...props }, ref) => {
    return (
      <Paper
        ref={ref}
        {...props}
        css={css`
          overflow: hidden;
        `}
      >
        {children}
      </Paper>
    );
  },
);
Card.displayName = "Card";
